import React, { Component } from 'react';

import { CloseCircleFilled } from '@ant-design/icons';
import { Elements } from '@stripe/react-stripe-js';
import { Input, message, Modal } from 'antd';
import '../../assets/style/itemStyle/addCardInformation.scss';
import CouponsItem from '../../components/public/Coupons';
import { couponsList } from '../../services/index';
import { getCountryList, submitMemberInfo } from '../../services/member/index';
import {
  divisionNumber,
  getLocalStorage,
  getSessionStorage,
  regularCheck,
  roll,
  timeZone,
} from '../../untils/auth';
import country from '../../untils/country.json';
import { stripePromise } from '../../untils/stripeKey';
import SetupIntent from './components/SetupIntent';
export default class AddCardInformation extends Component {
  state = {
    userId: getLocalStorage('userId') ? JSON.parse(getLocalStorage('userId')) : '', // 用户信息id
    user: getLocalStorage('user') ? JSON.parse(getLocalStorage('user')) : '', // 用户信息
    firstName: '', // 用户名',
    email: '', // 邮箱
    ruleFirstName: true, // 检验用户名
    ruleEmail: true, // 检验邮箱
    rulePhone: true, // 检验用户手机号
    countryCodeList: country, // 国家区号
    phoneCode: JSON.parse(getLocalStorage('user'))?.phoneCode || 1,
    countryCode: JSON.parse(getLocalStorage('user'))?.countryIso2 || 'US',
    phone: getLocalStorage('user') ? JSON.parse(getLocalStorage('user')).phone : '', // 用户手机号
    modalShow: false, // 优惠卷弹窗
    couponsList: [], // 优惠卷列表
    noCouponsList: [], // 不满足优惠卷列表
    couponIds: [], // 优惠卷id
    couponItem: {}, // 选中要使用优惠卷
    paymentList: ['Monthly subscribe - Cost:', 'Annual subscribe - Cost:'],
    membertripIndex: '', // 按月支付按年支付选择按钮
    memberData: {}, // 会员卡信息
    paymentPlan: '', // 按月支付按年支付
    seachValue: '',
    seachStateValue: '',
    couponPrice: 0, // 优惠价钱
    monthlyPrice: 0, // 月付价钱
    annualPrice: 0, // 年付价钱
    clientSecret: '', // 支付密钥
  };

  // 模糊搜索国家区号
  filterCode = (e) => {
    let countryCodeList = country.filter((item) => {
      return (
        item.countryName.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1 ||
        item.phoneCode.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1
      );
    });
    this.setState({
      countryCodeList,
    });
  };

  // 选择国家区号
  chooseCode = (item, type) => {
    if (type === 'phone') {
      this.setState({
        countrySelectShow: false,
        countryCodeList: country,
        phoneCode: item.phoneCode,
        countryCode: item.iso2,
      });
    }
    if (type === 'contactPhone') {
      this.setState({
        contactCountrySelectShow: false,
        countryCodeList: country,
        contactPhoneCode: item.phoneCode,
        contactCountryCode: item.iso2,
      });
    }
    if (type === 'country') {
      this.setState({
        selectCountryShow: false,
        countryName: item.name,
        ruleCountry: true,
        countryId: item.id,
        provinceName: '',
        seachStateValue: '',
      });
      let data = {
        countryId: item.id,
      };
      this.getStateList(data);
    }
    if (type === 'province') {
      this.setState({
        selectProvinceShow: false,
        provinceName: item.name,
        ruleProvince: true,
      });
    }
  };

  // 鼠标失去光标
  blur = (type, value) => {
    if (!value) return;

    if (type === 'firstName') {
      if (regularCheck('userName', value)) {
        this.setState({
          ruleFirstName: true,
        });
      } else {
        this.setState({
          ruleFirstName: false,
        });
      }
    }
    if (type === 'email') {
      if (regularCheck('email', value)) {
        this.setState({
          ruleEmail: true,
        });
      } else {
        this.setState({
          ruleEmail: false,
        });
      }
    }
    if (type === 'phone') {
      if (regularCheck('numberPhone', value)) {
        this.setState({
          rulePhone: true,
        });
      } else {
        this.setState({
          rulePhone: false,
        });
      }
    }
  };

  // 提交表单
  submitFrom = (e) => {
    e.preventDefault();

    let {
      user,
      userId,
      firstName,
      email,
      phoneCode,
      countryCode,
      phone,
      memberData,
      couponIds,
      paymentPlan,
    } = this.state;

    let ruleFirstName = regularCheck('registerName', firstName) || user.name ? true : false;
    let ruleEmail = regularCheck('email', email) || user.account ? true : false;
    let rulePhone = phone === '' ? false : true;

    let params = {
      name: user === '' ? firstName : user.name,
      email: user === '' ? email : user.account,
      phone: phone,
      phoneCode: phoneCode,
      paymentPlan: paymentPlan,
      couponIds: couponIds.length ? JSON.stringify(couponIds) : '[]',
      timeZone: timeZone(),
      membershipCardId: memberData.cardId,
      userId: userId === '' ? 0 : userId,
      phoneCountry: countryCode,
    };

    if (ruleFirstName && ruleEmail && rulePhone) {
      if (paymentPlan !== '') {
        submitMemberInfo(params).then((res) => {
          if (res.code) {
            this.setState({
              cardId: res.data.userCardId,
              clientSecret: res.data.clientSecret,
            });
          } else {
            message.warning(res.msg || 'failed to submit');
          }
        });
      } else {
        message.warning('Please select Payment Plan.');
      }
    }

    this.setState({
      ruleFirstName,
      ruleEmail,
      rulePhone,
    });
  };

  // 打开弹窗
  handleOk = () => {
    let { couponsList, noCouponsList } = this.state;
    if (!couponsList.length && !noCouponsList.length) {
      return message.warning('No coupon available.');
    }
    this.setState({
      modalShow: true,
    });
    let body = document.body;
    body.style.overflow = 'hidden';
  };
  // 关闭弹框
  handleCancel = () => {
    this.setState({
      modalShow: false,
    });
    let body = document.body;
    body.style.overflow = 'auto';
  };
  // 获取可用优惠卷list
  couponsList = () => {
    let memberData = getSessionStorage('memberPrice')
      ? JSON.parse(getSessionStorage('memberPrice'))
      : '';
    let type = '';
    if (memberData.cardType === 'Gold') {
      type = 'Gold Membership';
    } else if (memberData.cardType === 'Trial') {
      type =
        memberData.upgradeCardType?.cardType === 'Gold' ? 'Gold Membership' : 'Platinum Membership';
    } else {
      type = 'Platinum Membership';
    }
    couponsList(getLocalStorage('userId')).then((res) => {
      if (res.code && Object.keys(res.data).length > 0) {
        let meetList = res.data.coupons.filter((item) => {
          if (
            item.status === 1 &&
            item.cValue !== undefined &&
            (item.useEle.includes(type) || item.useEle.includes('All flight'))
          ) {
            if (
              !item.condType ||
              (item.condType === 1 && item.condValue !== undefined && item.condValue <= price)
            ) {
              return item;
            }
          }
          return null;
        });
        this.setState({
          couponsList: meetList,
          // noCouponsList: res.data,
        });
      }
    });
  };

  // 选中优惠卷
  selectedCoupons = (index) => {
    let { couponsList } = this.state;
    let isTrue = couponsList[index].type;
    for (let it of couponsList) {
      it.type = false;
    }
    couponsList[index].type = !isTrue;
    this.setState({
      couponsList,
    });
  };

  // 确定选中优惠卷
  confirmCoupons = () => {
    let { couponsList } = this.state;
    let item = {};
    for (const it of couponsList) {
      if (it.type) {
        item = it;
      }
    }
    // 计算价钱
    let price = this.calculatePrice(item);

    this.setState({
      ...this.state,
      couponIds: !item.couponId ? [] : [item.couponId],
      couponItem: item,
      modalShow: false,
      couponPrice: price,
    });
    let body = document.body;
    body.style.overflow = 'auto';
  };

  // 计算价钱
  calculatePrice = (couponItem) => {
    let { annualPrice } = this.state;
    let couponValue = 0;
    if (couponItem && Object.keys(couponItem).length > 0) {
      if (couponItem.cType === 'voucher') {
        couponValue = Number(couponItem.cValue);
      } else {
        couponValue = annualPrice * (Number(couponItem.cValue) / 100);
      }
    }
    return Math.ceil(couponValue);
  };

  // 选择月付年付
  changeIndex = (index) => {
    this.setState({
      membertripIndex: index,
    });
    if (index === 0) {
      this.setState({
        paymentPlan: 'monthly',
      });
    } else {
      this.setState({
        paymentPlan: 'annual',
      });
    }
  };

  // 获取会员卡价格信息
  getMemeberPrice = () => {
    let memberData = getSessionStorage('memberPrice')
      ? JSON.parse(getSessionStorage('memberPrice'))
      : '';
    this.setState({
      memberData,
      monthlyPrice:
        memberData.cardType === 'Trial'
          ? memberData.upgradeCardType?.monthlyPrice
          : memberData.monthlyPrice,
      annualPrice:
        memberData.cardType === 'Trial'
          ? memberData.upgradeCardType?.annualPrice
          : memberData.annualPrice,
    });
  };

  // 搜索国家列表
  getCountryList = (params) => {
    getCountryList(params).then((res) => {
      if (res.code) {
        this.setState({
          searchCountryList: res.data?.list || [],
        });
      }
    });
  };

  getStateShow = () => {
    if (this.state.stateList?.length > 0) {
      this.setState({
        selectProvinceShow: true,
      });
    }
  };

  // 关闭stripe支付弹窗
  closePayPopupHandle = () => {
    this.setState({
      clientSecret: '',
      cardId: '',
      getLoading: false,
    });
  };

  async componentDidMount() {
    roll(0);
    //  获取会员卡价格信息
    await this.getMemeberPrice();

    // 获取优惠卷列表
    if (getLocalStorage('user')) {
      await this.couponsList();
    }
  }
  render() {
    let {
      user,
      firstName,
      email,
      ruleFirstName,
      ruleEmail,
      rulePhone,
      phoneCode,
      countryCode,
      countrySelectShow,
      countryCodeList,
      phone,
      modalShow,
      couponsList,
      couponItem,
      noCouponsList,
      paymentList,
      membertripIndex,
      memberData,
      annualPrice,
      monthlyPrice,
      couponPrice,
      clientSecret,
      cardId,
    } = this.state;
    return (
      <div className="information-form">
        <div className="top">
          <i className="bg-image" onClick={() => this.props.history.push('/membership')}></i>
          <span>Account information</span>
        </div>
        <div className="content">
          <form className="form" id="membership-form" onSubmit={this.submitFrom}>
            {user === '' ? (
              <div className="two-item">
                <div className="left">
                  <p>UserName</p>
                  <input
                    type="text"
                    placeholder={'User name'}
                    value={firstName}
                    className={!ruleFirstName ? 'error' : ''}
                    onChange={(e) => this.setState({ firstName: e.target.value })}
                    onBlur={(e) => this.blur('firstName', e.target.value)}
                  />
                  {!ruleFirstName && (
                    <div className="error-text">
                      <span>Please enter your name in English</span>
                    </div>
                  )}
                </div>
                <div className="right">
                  <p>Email</p>
                  <input
                    type="text"
                    placeholder={'Email address'}
                    value={email}
                    className={!ruleEmail ? 'error' : ''}
                    onChange={(e) => this.setState({ email: e.target.value })}
                    onBlur={(e) => this.blur('email', e.target.value)}
                  />
                  {!ruleEmail && (
                    <div className="error-text">
                      <span>Please enter a valid email address</span>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="two-item">
                <div className="left">
                  <p>UserName</p>
                  <div className="name-email">{user.name}</div>
                </div>
                <div className="right">
                  <p>Email</p>
                  <div className="name-email">{user.account}</div>
                </div>
              </div>
            )}
            <div className="two-item">
              <div className="left">
                <p>Phone Number</p>
                <div className={`code ${!rulePhone ? 'error' : ''}`}>
                  <div onClick={() => this.setState({ countrySelectShow: true })}>
                    <img
                      src={`${
                        process.env.REACT_APP_ASSET_URL
                      }/country/${countryCode.toLowerCase()}.webp`}
                      alt="flag"
                      className="flag"
                    />
                    <img
                      src={require('../../assets/imgs/svg/black-down-sanjiao.svg').default}
                      alt="down icon"
                      className="sanjiao"
                    />
                    <span>+{phoneCode}</span>
                  </div>
                  <input
                    type="number"
                    placeholder={'Mobile number'}
                    value={phone || ''}
                    onChange={(e) => this.setState({ phone: e.target.value })}
                    onBlur={(e) => this.blur('phone', e.target.value)}
                  />
                </div>
                {!rulePhone && (
                  <div className="error-text">
                    <span>Please enter a valid 6-11 digit phone</span>
                  </div>
                )}
                {countrySelectShow ? (
                  <>
                    <div className="country-code">
                      <Input placeholder="Search" onChange={(e) => this.filterCode(e)} />
                      <ul>
                        {countryCodeList.map((item, index) => {
                          return (
                            <li key={index} onClick={() => this.chooseCode(item, 'phone')}>
                              <div>
                                <img
                                  src={`${
                                    process.env.REACT_APP_ASSET_URL
                                  }/country/${item.iso2.toLowerCase()}.webp`}
                                  alt="flag"
                                />
                                <span className="countryname">{item.countryName}</span>
                              </div>
                              <span>{item.phoneCode}</span>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                    <div
                      className="country-code-mask"
                      onClick={() =>
                        this.setState({
                          countrySelectShow: false,
                          countryCodeList: country,
                        })
                      }
                    ></div>
                  </>
                ) : null}
              </div>
            </div>
          </form>
          {user !== '' ? (
            <div className="coupon" onClick={() => this.handleOk()}>
              <div className="title">Choose a coupon</div>
              <div
                className={`choose-coupon  ${
                  !couponsList.length && !noCouponsList.length ? 'no-coupons' : ''
                }`}
              >
                <p>
                  {!Object.keys(couponItem).length ? (
                    !couponsList.length && !noCouponsList.length ? (
                      <>
                        <b>No coupons available</b>
                      </>
                    ) : (
                      'Choose a coupon'
                    )
                  ) : couponItem.cType === 'voucher' ? (
                    <span>{`Chosen：$ ${couponItem.cValue} Coupon`}</span>
                  ) : (
                    <span>{`Chosen：${couponItem.cValue}% OFF Coupon`}</span>
                  )}
                </p>
                <i className="bg-image"></i>
              </div>
            </div>
          ) : null}
          <div className="payment">
            <div className="title">
              <span>Payment Plan</span>(
              {memberData.cardType === 'Trial'
                ? 'Please select the upgraded gold membership card deduction method'
                : 'Payment will be charged automatically'}
              )
            </div>
            <div className="payment-plan">
              {paymentList.map((item, index) => {
                return (
                  <span
                    key={index}
                    className={`${membertripIndex === index ? 'active' : ''}  ${
                      index === 0 ? (couponPrice === 0 ? 'isShow' : 'isNot') : 'isShow'
                    }`}
                    onClick={() => this.changeIndex(index)}
                  >
                    <i className="bg-image"></i>
                    {item} $
                    {index === 0
                      ? divisionNumber(monthlyPrice)
                      : divisionNumber(annualPrice - couponPrice) < 0
                      ? 0
                      : divisionNumber(annualPrice - couponPrice)}
                  </span>
                );
              })}
            </div>
            <div className="credit-card">
              <span>Credit or Debit Card</span>
              <div>
                <img
                  src={require('../../assets/imgs/webp/card-logo.webp').default}
                  alt="logo card"
                />
              </div>
            </div>
          </div>
          <p>
            By clicking the "Start Membership" button below, you agree to our{' '}
            <a href="/membershipPolicy" target="_blank">
              Membership Policy
            </a>
            ,Your payment is encrypted,Secure for peace of mind. Cancel easily online.
          </p>
          <button className="start-btn" type="submit">
            Start Membership
          </button>
        </div>
        {/* 支付弹窗 */}
        {clientSecret && (
          <div className="member-strip">
            <div className="member-strip-content">
              <Elements stripe={stripePromise} options={{ clientSecret }}>
                <SetupIntent
                  cardId={cardId}
                  userName={firstName || user.name}
                  closePayPopupHandle={this.closePayPopupHandle}
                />
              </Elements>
            </div>
          </div>
        )}
        {/* 优惠卷弹窗 */}
        <Modal
          maskClosable={false}
          closeIcon={<CloseCircleFilled />}
          className="pay-coupons-container coupons-box"
          title="Coupons"
          getContainer={() => document.getElementById('layout')}
          maskStyle={{ backdropFilter: 'blur(10px)' }}
          centered={true}
          destroyOnClose={true}
          open={modalShow}
          footer={null}
          onCancel={this.handleCancel}
        >
          <div className="coupons-modal">
            <div className="coupons-list">
              <div className="coupons-title">Choose a coupon</div>
              {couponsList.map((item, index) => {
                return (
                  <div
                    className={`list-coupons-item ${item.type ? 'active' : ''}`}
                    key={index}
                    onClick={() => this.selectedCoupons(index)}
                  >
                    <CouponsItem item={item} pay={true} />
                  </div>
                );
              })}
              {noCouponsList.length > 0 && couponsList.length > 0 ? (
                <p className="coupons-line bg-image"></p>
              ) : null}

              {noCouponsList.map((item, index) => {
                return (
                  <div key={index}>
                    <CouponsItem
                      item={item}
                      pay={true}
                      //   price={
                      //     tripIndex === 0 ? details.price : details.price * 2
                      //   }
                    />
                    <p className="dissatisfy-why">
                      <span>Reason for unavailability：</span>Amount not satisfied
                    </p>
                  </div>
                );
              })}
            </div>
            {!couponsList.length ? null : (
              <div className="confirm-coupons bg-image" onClick={() => this.confirmCoupons()}>
                Confirm
              </div>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}
